import { ListBaseModel } from '@/api/models';
import { sheetTypeEnum } from '@/utils/enum';
import z from 'zod';

export const GroupProjectListModel = ListBaseModel.extend({
  results: z
    .object({
      id: z.string().uuid(),
      sheetType: sheetTypeEnum,
      fiscalYear: z.number().int(),
      name: z.string(),
      isLocked: z.boolean(),
      isPublished: z.boolean(),
      projectNumber: z.number().int().nullable(),
      startYear: z.number().int().nullable(),
      endYear: z.number().int().nullable(),
      overview: z.string().nullish(),
      purpose: z.string().nullish(),
      task: z.string().nullish(),
    })
    .array(),
});
